export const SET_ENVIRONMENTS = 'SET_ENVIRONMENTS';
export const SET_CONNECTED_ENVIRONMENTS = 'SET_CONNECTED_ENVIRONMENTS';
export const RUN_ENVIRONMENT = 'RUN_ENVIRONMENT';
export const SET_TEMPLATES = 'SET_TEMPLATES';
export const SET_CONNECTED_TEMPLATES = 'SET_CONNECTED_TEMPLATES';
export const SET_PRIVATE_TEMPLATES = 'SET_PRIVATE_TEMPLATES';
export const SET_REGIONS_PER_PROVIDER = 'SET_REGIONS_PER_PROVIDER';
export const SET_SIZES = "SET_SIZES"

export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_LOGGED_OUT = 'SET_LOGGED_OUT';
export const SET_COGNITO_INFO = 'SET_COGNITO_INFO';
export const SET_CREDENTIALS = 'SET_CREDENTIALS';
export const SET_NEEDS_VERIFICATION = 'SET_NEEDS_VERIFICATION';
export const CLEAR_CREDENTIALS = 'CLEAR_CREDENTIALS';
export const SET_VERIFIED = 'SET_VERIFIED';
export const SET_AUTH_ERRORS = 'SET_AUTH_ERRORS';

export const SNACKBAR = 'SNACKBAR';
export const ERROR_SNACKBAR = 'ERROR_SNACKBAR';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';

export const SET_CONNECTED_TEMP_DETAILS = 'SET_CONNECTED_TEMP_DETAILS'

export const SET_DETAILS = 'SET_DETAILS';
export const SET_CONNECTED_ENV_DETAILS = 'SET_CONNECTED_ENV_DETAILS';
export const SET_SNAPSHOTS = 'SET_SNAPSHOTS';
export const SET_SNAPSHOT_STATUS = 'SET_SNAPSHOT_STATUS';
export const SET_DURING_RESTORING = 'SET_DURING_RESTORING';

export const SET_USERS = 'SET_USERS';
export const SET_SUB = 'SET_SUB';
export const SET_SHARED_WITH = 'SET_SHARED_WITH';

export const SET_USER_EMAIL_ADDRESS = 'SET_USER_EMAIL_ADDRESS';

export const SET_LOADING_OVERLAY = 'SET_LOADING_OVERLAY';
export const SET_SSH_KEYS = 'SET_SSH_KEYS';
export const SET_ENVIRONMENT_SSH_KEYS = 'SET_ENVIRONMENT_SSH_KEYS';

export const SET_ENVIRONMENT_STATUS = 'SET_ENVIRONMENT_STATUS';

export const SET_USER_GROUPS = 'SET_USER_GROUPS';

export const REMOVE_TEMPLATE_FROM_LIST = 'REMOVE_TEMPLATE_FROM_LIST';

export const SET_ESTIMATED_COST = 'SET_ESTIMATED_COST';
export const SET_ESTIMATED_COST_PERIOD = 'SET_ESTIMATED_COST_PERIOD';
export const SET_SCHEDULER_STATUS = 'SET_SCHEDULER_STATUS';
